import { CubeFolder } from '@dc-shared-web/lib/cubeMappers'
import { AxiosInstance } from 'axios'
import { omitBy } from 'lodash'

export interface FetchFoldersParams {
  teamUuid: string | null
  folderUuid?: string | null
}

export const fetchFolders = async (
  apiClient: AxiosInstance,
  params: FetchFoldersParams
) => {
  const truthyParams = omitBy(params, (value) => !value)
  const { data: axiosData } = await apiClient.get<{ data: CubeFolder[] }>(
    '/ajax/cube/folders',
    {
      params: {
        currentTeamUuid: truthyParams.teamUuid,
        folderUuid: truthyParams.folderUuid,
      },
    }
  )
  return axiosData.data
}
